import { render, staticRenderFns } from "./ProfessionalListAddNew.vue?vue&type=template&id=319c1014&"
import script from "./ProfessionalListAddNew.vue?vue&type=script&lang=js&"
export * from "./ProfessionalListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalListAddNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports